import { APPLICATION_ACTION_COMPELTE_STATUSES, APPLICATION_ACTION_OPEN_STATUSES, APPLICATION_ACTION_SUBMITTED_STATUSES, APPLICATION_APPROACH, APPLICATION_STATUS } from "../enums/application.enum";
import { USER_ROLES } from "../enums/user.enum";
import { UserService } from "../services/user.service";
import { AlsdeUser } from "./alsde-user.model";
import { ApplicationWizard } from "./application-wizard.model";
import { Artifact } from "./artifact.model";
import { Case } from "./case.model";

export class IAppList {
    all: ApplicationWizard[] = [];
    active: ApplicationWizard[] = [];
    history: ApplicationWizard[] = [];
    actionRequired: ApplicationWizard[] = [];
    inProgress: ApplicationWizard[] = [];
    submitted: ApplicationWizard[] = [];
}
export class AppList extends IAppList {

    constructor(userService:UserService, appList?: any) {
        super();
        if (appList) {
            appList.map((item:ApplicationWizard)=>{
                const app = new ApplicationWizard(userService, item);
                this.all.push(app);

                if(APPLICATION_ACTION_OPEN_STATUSES.includes(app.status?.Value || APPLICATION_STATUS.STARTED)){
                    this.active?.push(app);
                    if(app.isActionPending && app.applicantSigned){
                        this.actionRequired.push(app);
                    }else{
                        this.inProgress.push(app);
                    }
                }

                if(APPLICATION_ACTION_SUBMITTED_STATUSES.includes(app.status?.Value || APPLICATION_STATUS.STARTED)){
                    this.active?.push(app);
                    this.submitted?.push(app);
                }
                
                if(APPLICATION_ACTION_COMPELTE_STATUSES.includes(app.status?.Value || APPLICATION_STATUS.STARTED)){
                    this.history?.push(app);
                }
            })
        }
    }

    toJSON() {
        return {}
    }
}